// extracted by mini-css-extract-plugin
export var animation_block = "rocksFalling-module--animation_block--65c4c";
export var bg = "rocksFalling-module--bg--16101";
export var fall = "rocksFalling-module--fall--9d710";
export var reveal = "rocksFalling-module--reveal--8f1f3";
export var rock = "rocksFalling-module--rock--0f2b3";
export var rock_1 = "rocksFalling-module--rock_1--0b470";
export var rock_2 = "rocksFalling-module--rock_2--dc34a";
export var rock_3 = "rocksFalling-module--rock_3--e794f";
export var rock_4 = "rocksFalling-module--rock_4--d8038";
export var rotate = "rocksFalling-module--rotate--0ba9d";